import React from 'react';
import ScrollReveal from '../../utils/animations/ScrollReveal';
import { useInView } from 'react-intersection-observer';

function Jogo() {
  const { ref: jogoRef, inView: inViewJogo } = useInView();

  return (
    <div className="jogo py-4 px-4 md:py-28 md:px-40  flex flex-col gap-5 md:gap-12 w-full">
      <ScrollReveal>
        <div
          ref={jogoRef}
          className={`${
            inViewJogo ? 'fade-in-left' : ''
          } text-4xl md:text-6xl font-black text-white uppercase `}
        >
          Para o Professor{' '}
        </div>
      </ScrollReveal>
      <div className="">
        <ScrollReveal className="text-sm md:text-start md:text-lg text-white font-semibold mb-5 max-w-[70ch]">
          Esta seção é dedicada aos professores que desejarem utilizar o jogo
          Mistura Explosiva com seus alunos. Em sala de aula, o aprendizado de
          conteúdos como reações químicas; soluções e misturas; concentrações;
          nomenclatura das substâncias químicas; segurança no manuseio de
          substâncias químicas, entre vários outros, pode ser facilitado com a
          utilização do jogo. O material disponibilizado para download no link a
          seguir é de natureza instrucional.
        </ScrollReveal>
      </div>
      <div className="w-full">
        <button
          className="shadow-md px-20 2xl:px-28 py-2 rounded-xl bg-mOrange text-white text-xl font-black hover:bg-[#ccc] duration-300"
          href="/docs/Paper - Mistura Explosiva.pdf"
          download="Paper - Mistura Explosiva.pdf"
          target="_blank"
        >
          Download do Material
        </button>
      </div>
    </div>
  );
}

export default Jogo;
